<template>
  <default-layout>
    <event-navbar title="Event Home" />
    <v-runtime-template :template="event_content"></v-runtime-template>
    <hr class="mx-3">
    <p class="text-center text-muted small mb-4">
      <router-link to="/about">Über diese App</router-link>
    </p>
  </default-layout>
</template>

<script>
// @ is an alias to /src
import VRuntimeTemplate from "v-runtime-template";
import DefaultLayout from '@/components/DefaultLayout.vue'
import EventNavbar from '@/components/EventNavbar.vue'

export default {
  name: 'EventHomeView',
  components: {
    VRuntimeTemplate, DefaultLayout, EventNavbar
  },
  data() {
    return {
      event_content: '',
    }
  },

  created() {
      this.$storage.fetchUser()  // to update the favorite storage
      let me = this
      if (navigator.onLine) {
        this.$api.get(`zpcard/${this.$route.params.shortName}/`).then((response) => {
          me.event_content = response.data.html
          localStorage.setItem('zpcard-event-home', me.event_content)
        })
      } else {
          me.event_content = localStorage.getItem('zpcard-event-home')
      }
  },

}
</script>
